import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IDVRType } from "../types";
import { editStateDVRType } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

export const DVRTypeDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IDVRType | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = userPermissions.includes(
    PERMISSIONS.permission_utilities_securityconfiguration_dvrtype_delete
  );

  // Recoil Hook
  const edit = useRecoilValue(editStateDVRType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks

  const [inputData, setInputData] = useState(data?.dvrTypeName || "");

  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-1 md:grid-cols-3 mx-3 pb-2 gap-2 gap-x-2 py-2">
            <div className="my-1 mx-3">
              <TextInputLabelHookForm
                name="dvrTypeName"
                label="DVR Type Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.dvrTypeName &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.dvrTypeName &&
                  formMethods.formState.errors.dvrTypeName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("dvrTypeName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1 mx-3">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  onClick={(e) => {
                    if (!deletePermission && data?.isActive) return;
                    setCheckBoxChanges(e.target.checked);

                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        inputData === data?.dvrTypeName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  disabled={!deletePermission && data?.isActive ? true : false}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DVRTypeDetails;
